import { upperCase } from "lodash";

import { SeparatorWithTextWrapper, TextDisplay } from "src/styled";
import { SeparatorText } from "src/styled/Separator";

interface Props {
  text: string;
}

const SeparatorWithText = ({ text }: Props) => {
  return (
    <SeparatorWithTextWrapper>
      <SeparatorText>
        <TextDisplay size="medium" block align="center">
          {upperCase(text)}
        </TextDisplay>
      </SeparatorText>
    </SeparatorWithTextWrapper>
  );
};

export default SeparatorWithText;
